import {Loading} from 'element-ui';
import {FileDownloadResponse, UserTrace} from '@/model/CommonModel';
import MessageUtils from '@/utils/MessageUtils';
import AppSession from '@/store/AppSession';
import UserAuthenticationApi from '@/api/UserAuthentication';
import {Route} from 'vue-router';
import axios from 'axios';
import SystemAdminApi from '@/api/SystemAdminApi';
import {trackerUserLogout} from '@/plugins/raygun';

// const tracerEndpoint = 'https://cubelogger.crscube.io';
// const clientId = 'APP_SAFETY_R3';
// const profile = resolveProfile();

// function resolveProfile() {
//     const hostname = location.hostname;
//     if (hostname.startsWith('localhost') || hostname.endsWith('.cn')) {
//         return 'UNKNOWN';
//     } else if (hostname.startsWith('dev-')) {
//         return 'DEV';
//     } else if (hostname.startsWith('stg-')) {
//         return 'STG';
//     } else if (hostname.startsWith('edu-')) {
//         return 'EDU';
//     } else {
//         return 'SVC';
//     }
// }

export interface ApiCallOption {
    loading: boolean;
}

export default class ApiUtils {
    public static readonly DEFAULT_LOADING_OPTION = {
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    };
    
    public static rejectedHandler = (rejected: any) => {
        if (rejected?.errMsg) {
            MessageUtils.displayErrorMessage(rejected.errMsg);
        } else {
            MessageUtils.displayErrorMessage(rejected.message);
        }
    }
    
    public static fileDownloadHandler = (result: FileDownloadResponse) => {
        const fileURL = window.URL.createObjectURL(new Blob([result.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', decodeURIComponent(result.fileName.replace(/[+]/g, '%20')));
        document.body.appendChild(fileLink);
        fileLink.click();
    }
    
    public static callApi(api: Promise<any>,
                          onSuccess: (res: any) => void = (res: any) => {
                          },
                          options: ApiCallOption = {loading: false}): void {
        ApiUtils.callApiAddOnErrorCallback(api, onSuccess, error => {
        }, options);
    }
    
    public static callApiAddOnErrorCallback(api: Promise<any>,
                                            onSuccess: (res: any) => void = (res: any) => {
                                            },
                                            onError: (err: any) => void = (err: any) => {
                                            },
                                            options: any = {}): void {
        let loading = {
            close: () => {
            }
        };
        if (options.loading) {
            loading = Loading.service(ApiUtils.DEFAULT_LOADING_OPTION);
        }
        try {
            api.then(response => {
                loading.close();
                onSuccess(response);
            }, rejected => {
                loading.close();
                onError(rejected);
            }).catch(e => {
                loading.close();
                onError(e);
            });
        } catch (e) {
            loading.close();
        }
    }
    
    public static isFailToFileDownloadResponse(res: any) {
        const contentDisposition = res.headers['content-disposition'];
        const contentType = res.headers['content-type'];
        return !contentType || contentType.includes('application/json')
            || !contentDisposition || res.success === false || res.status !== 200;
    }
    
    public static handleFileDownloadFailResponse(res: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const data: any = reader.result;
                resolve(Promise.reject(JSON.parse(data)));
            };
            reader.onerror = (e) => reject(e);
            reader.readAsText(res.data);
        });
    }
    
    public static handleFileDownloadSuccessResponse(res: any): Promise<FileDownloadResponse> {
        const contentDisposition = res.headers['content-disposition'];
        const [fileNameMatch] = contentDisposition.split(';').filter((str: string) => str.includes('filename'));
        let fileName = '';
        if (fileNameMatch) {
            [, fileName] = fileNameMatch.split('=');
        }
        return Promise.resolve({data: res.data, fileName});
    }
    
    public static logout(sponsorKey: string, reason: string, $store: any, $tick: any, $route: Route) {
        const logout = $route.meta.isAdmin ? SystemAdminApi.systemAdminLogout(reason)
                                              : UserAuthenticationApi.logout(sponsorKey, reason);

        logout.then(() => {
            $store.commit('clear');
            AppSession.logout();
            clearInterval($tick);
            trackerUserLogout();
            window.location.href = `/login/${ApiUtils.getLanguage($route)}`;
        });
    }

    public static extractRequiredParams(param: any) {
        const {sponsorKey, sessionSenderKey, language, appendix} = param;
        return {sponsorKey, sessionSenderKey, language: language ?? 'en', appendix};
    }
    
    public static getLanguage($route: Route): string {
        return $route.params.language ? $route.params.language : 'en';
    }

    public static convertLanguageToCountryCode($route: Route): string {
        let lang = this.getLanguage($route);
        if (lang === 'zh') {
            lang = 'cn';
        }
        return lang;
    }
    
    public static reportError(category: string, obj: any) {
        // const data = {
        //     level: 'FATAL',
        //     category,
        //     ...obj
        // };
        // ApiUtils.sendLog('/api/v1/logs/error', data);
    }
    
    public static trace(data: UserTrace) {
        // ApiUtils.sendLog('/api/v1/logs/traces', data);
    }
    
    public static sendLog(uri: string, data: any) {
        // if (profile === 'UNKNOWN') {
        //     return;
        // }
        // axios.post(`${tracerEndpoint}${uri}?ignore=ALL`, {
        //     ...data,
        //     clientId,
        //     profile,
        // }, {
        //     params: {
        //         ignore: 'ALL'
        //     }
        // });
    }
    
    public static getHash(): string {
        return `r-${Math.random().toString(36).substring(7)}`;
    }
}
